module.exports = __webpack_public_path__ + "static/media/4.f43a87f6.jpg";